<template>
  <div :class="['flex items-center', noBorder ? '' : 'border-b border-gray-200']">
    <component
      :is="tab.to ? 'router-link' : 'button'"
      v-for="tab in normalizedTabs"
      :key="tab.id || tab.label"
      :to="tab.to || undefined"
      :type="tab.to ? undefined : 'button'"
      style="font-size: 13px;"
      :class="[
        'px-3 py-2.5 font-medium border-b-2 -mb-px transition-colors no-underline cursor-pointer bg-transparent',
        isActive(tab)
          ? 'border-gray-900 text-gray-900'
          : 'border-transparent text-gray-500 hover:text-gray-700'
      ]"
      @click="switchTab(tab)"
    >
      <font-awesome-icon v-if="tab.icon" :icon="tab.icon" class="mr-1 text-xs" />
      {{ tab.label }}
    </component>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'Page_Tabs',
  components: {
    FontAwesomeIcon,
  },
  props: {
    initialTab: {
      type: String,
      default: ''
    },
    // Each item: string | { label, id?, icon?, to? }
    // When `to` is provided, the tab renders as a router-link
    // When `id` is provided, it is used for matching and emitting instead of label
    tabs: {
      type: Array,
      required: true
    },
    noBorder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentTab() {
      return this.initialTab;
    },
    normalizedTabs() {
      return this.tabs.map(tab =>
        typeof tab === 'string' ? { label: tab } : tab
      );
    },
  },
  methods: {
    isActive(tab) {
      if (tab.to) {
        return this.$route.path === tab.to || this.$route.path.startsWith(tab.to + '/');
      }
      return this.currentTab === (tab.id || tab.label);
    },
    switchTab(tab) {
      this.$emit('select', tab.id || tab.label);
    }
  }
}
</script>

<style scoped>
a.no-underline {
  text-decoration: none;
  color: inherit;
}

a.no-underline:hover {
  color: inherit;
}
</style>
